module.exports = __webpack_public_path__ + "img/10.a968acf6.png";